import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import BankTransactionsWillMount from "../../../Middleware/Middlewares/BankTransactionsWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import Constants from "../../../Action/Constants";
import Card from '@material-ui/core/Card';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";

class BankTransactions extends Component {
  protected selectedPayment: PaymentInterface;
  protected selectedPaymentIndex: number;
  protected paginatorPath: string;
  public noteField: null;
  protected timerId: any;
  protected fileInput;

  protected middlewares: MiddlewareInterface[] = [
    BankTransactionsWillMount
  ];

  public state = {
    payments: [],
    unusedPayments: [],
    isFetching: true,
    filterValue: "",
    agencyBankAccountId: "all",
    filter: "unused",
    paymentsCount: 0,
    unusedPaymentsCount: 0,
    paymentToDelete: null,
    isPaymentRemovePopupOpen: false,
    isPaymentUnSettlePopupOpen: false,
    isPaymentUnlinkPopupOpen: false,
    dateFilter: null,
    cannotDeleteSavingsPaymentDialog: false,
    searchInProgress: false,
    paymentToAddNote: null,
    note: "",
    memoPopupOpen: false,
    isUndoSavingsPopupOpen: false,

    isBankTransactionsDilaogOpen: false,
    isDialogOpen: false,
    isSaving: false,
    isBankTransFileRemoveOpen: false,
    transactionFile: null,
    anchorEl: null,
  }

  constructor(public props) {
    super(props);

    this.fileInput = React.createRef();
  }

  public fetchFirstAllPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      // agencyBankAccount: this.state.agencyBankAccountId,
      // filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date,
      isBankTransaction: 1,
    };

    // if (!!this.state.dateFilter) {
    //   payload.date = this.state.dateFilter;
    // }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.setState({
          searchInProgress: false,
          payments: data.payments,
          paymentsCount: data.count,
          isFetching: false
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        })
      }
    });
  }

  public fetchFirstUnusedPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      // isFullyUsed: 0, // unused payments
      // agencyBankAccount: this.state.agencyBankAccountId,
      // filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      isBankTransaction: 1,
      isProcessed: 0, // not verified payments 
    };

    // if (!!this.state.dateFilter) {
    //   payload.date = this.state.dateFilter;
    // }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        unusedPayments: data.payments,
        unusedPaymentsCount: data.count,
        isFetching: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      })
    });
  }

  public fetchPayments = () => {
    if (this.state.filter === "all") {
      const payload: any = {
        firstItem: !!this.state.payments ?  this.state.payments.length : 0,
        lastItem: !!this.state.payments && this.state.payments ? this.state.payments.length + this.props.app.defaultPaginationAmount : 0,
        // agencyBankAccount: this.state.agencyBankAccountId,
        // filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        isBankTransaction: 1,
      };

      // if (!!this.state.dateFilter) {
      //   payload.date = this.state.dateFilter;
      // }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const paymentsArr: PaymentInterface[] = !!this.state.payments ?
                                                  [...this.state.payments, ...data.payments] : [...data.payments];

          this.setState({
            payments: paymentsArr,
            count: data.count
          });
        }
      });
    } else if (this.state.filter === "unused") {
      const payload: any = {
        firstItem: !!this.state.unusedPayments ?  this.state.unusedPayments.length : 0,
        lastItem: !!this.state.unusedPayments && this.state.unusedPayments ?
                                                  this.state.unusedPayments.length + this.props.app.defaultPaginationAmount : 0,
        // isFullyUsed: 0, // unused payments
        // agencyBankAccount: this.state.agencyBankAccountId,
        // filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        isBankTransaction: 1,
        isProcessed: 0, // not verified payments 
      };

      // if (!!this.state.dateFilter) {
      //   payload.date = this.state.dateFilter;
      // }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const unusedPaymentsArr: PaymentInterface[] = !!this.state.unusedPayments ?
                                          [...this.state.unusedPayments, ...data.payments] : [...data.payments];

          this.setState({
            unusedPayments: unusedPaymentsArr,
            unusedPaymentsCount: data.count
          });
        }
      });
    }
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.paginatorPath = `Finance_Bank_Transactions_${this.state.filter}`;

      this.props.dispatch({
        type: Constants.FINANCE_BANK_TRANSACTIONS_FILTER_UPDATE_STATE,
        payload: {
          filter: filter
        }
      });

      if (filter === "all") {
        this.fetchFirstAllPayments();
      } else if (filter === "unused") {
        this.fetchFirstUnusedPayments();
      }
    });
  }

  public getAmountsOfFilteredPayments = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.paymentsCount;
      case "unused":
        return this.state.unusedPaymentsCount;
      default:
        return;
    }
  }

  public getFilteredPayments = (filter: string): PaymentInterface[] => {
    let payments = [];

    switch (filter) {
      case "all":
        payments = [...this.state.payments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      case "unused":
        payments = [...this.state.unusedPayments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      default:
        break;
    }

    return payments;
  }

  public saveScrollPosition = () => {
    var top  = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYMENTS_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public getPaymentsForList = () => {
    return this.getFilteredPayments(this.state.filter)
      .map((payment: PaymentInterface, index: number) => {
        if (!payment) {
          return;
        }

        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        return (
          <TableRow
            hover
            key={`payment-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              this.props.dispatch({
                type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
                payload: {
                  payments: this.getFilteredPayments(this.state.filter).slice(0, this.getFilteredPayments(this.state.filter).findIndex(pmnt => pmnt?.id === payment?.id))
                }
              });

              this.redirect(`/app/payment/update/${payment.id}`);
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: color}}
                  className="icon icon-ic-payment"
                ></div>
              </div>
            </TableCell>
            <TableCell style={{width: "10%"}}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{width: "50%"}}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell style={{width: "15"}}>
              <div style={{display: "flex", justifyContent: "center"}}>
                {
                  payment.removed && <div>{this.trans("removed")}</div>
                }
                {
                  !payment?.removed && payment?.hasTransaction && !payment?.isProcessed &&
                  <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="list-label creation-type-label red">
                      {this.trans("to-verify")}
                    </div>
                </div>
                }
              </div>
            </TableCell>
            <TableCell>
              {payment.creationTypeDisplayName && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div className="list-label creation-type-label">
                    {payment.creationTypeDisplayName}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{textAlign: "right", width: "25%", paddingRight: "20px" }}>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable")  && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false
    });
  }

  public upload = (e: any): any => {
    const file = e.target.files[0];

    this.setState({
      isBankTransactionsDilaogOpen: false
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_SET_TITLE,
      payload: {
        title: this.trans("uploading")
      }
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_OPEN_DIALOG
    });

    this.setState({
      isDialogOpen: true
    });

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.props.dispatch({
        type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_START,
        payload: {
          transactionFile: true,
          result: reader.result,
          file: file
        },
        onSuccess: transactionFile => {
          this.setState({
            transactionFile: transactionFile
          }, this.forceUpdate);
        },
        onError: () => {
          this.props.dispatch({
            type: Constants.PAGE_BANK_TRANSACTIONS_CLOSE_DIALOG
          });

          this.setState({
            isDialogOpen: false
          });
        }
      });
    };

    e.target.value = null;
  }

  public renderDialogContent = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    // Uploading
    if (!!fileDetails && fileDetails.state === 1) {
      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt940-is-uploading")}</p>
          <CircularProgress size={40} thickness={2} />
        </div>
      );
    }

    // Processing
    if (!!fileDetails && fileDetails.state === 2) {
      if (!!fileDetails && fileDetails.current !== fileDetails.total) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.setState({
            isDialogOpen: false
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("mt-940-uploading-is-crashed"),
              type: "error"
            }
          });
        }, 30000);
      }

      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt-940-is-processing")}</p>
          <p>{this.trans("processing-x-of-y", { x: !!fileDetails && fileDetails.current, y: !!fileDetails && fileDetails.total })}</p>
          <div style={{padding: "0 24px"}}>
            <LinearProgress
              variant="determinate"
              value={100 / (!!fileDetails && fileDetails.total) * (!!fileDetails && fileDetails.current)}
            />
          </div>
        </div>
      );
    }

    // Success
    if (!!fileDetails && fileDetails.state === 3) {
      clearTimeout(this.timerId);

      return (
        <div>
          <p>{this.trans("mt-940-processing-finished-1")}</p>
            <ul>
              <li>
                <p>{this.trans("mt-940-processing-finished-total-count-payments", {count: !!fileDetails && fileDetails.current})}</p>
              </li>
              <li>
                <p>{this.trans("mt-940-processing-finished-created-count-payments", {count: !!fileDetails && fileDetails.countOfCreatedPayments})}</p>
              </li>
              {
                !!fileDetails && !!fileDetails.countOfExistingPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-existing-count-payments", {count: !!fileDetails && fileDetails.countOfExistingPayments})}</p>
                  </li>
                )
              }
              {
                !!fileDetails && !!fileDetails.countOfNotRecognizedPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-not-recognized-count-payments", {count: !!fileDetails && fileDetails.countOfNotRecognizedPayments})}</p>
                  </li>
                )
              }
            </ul>
          <p>{
            this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0) ? this.trans("mt-940-processing-finished-2-close") :
            // this.trans("mt-940-processing-finished-2")
            ""
            }</p>
        </div>
      );
    }

    // Fail
    if (this.props.component.error) {
      return (
        <div>
          {this.image.getAvatar("info", { size: 75 })}
          <p>{this.props.component.translatedMessage}</p>
        </div>
      );
    }
  }

  public determineTitle = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    if (!!fileDetails && fileDetails.disableButton === true) {
      return this.trans("title-please-wait");
    }

    if (this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0)) {
      return this.trans("button-close");
    }

    return this.trans("button-continue");
  }

  public close = (): any => {
    this.setState({
      isDialogOpen: false
    });
  }

  public continue = (): any => {
    this.close()

    this.fetchFirstAllPayments(() => {
      window.scrollTo({
        top: this.props.app?.financeBankTransactionsListPosition
      });
    });
    this.fetchFirstUnusedPayments(() => {
      window.scrollTo({
        top: this.props.app?.financeBankTransactionsListPosition
      });
    });
  }

  public closeBankTransactionsDialog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: false,
    })
  }

  public openBankTransactionsDilaog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: true,
    })
  }

  public render() {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-finance")}</h1>
            <TabsComponent
              activeTab={2}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
            <div
                className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline"
                }}
              >
                <h3 className="card-title">
                  {this.trans("bank-transactions")}
                </h3>

                <div className="button-container">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={this.openBankTransactionsDilaog}
                  >
                    {this.trans("upload-mt940-file")}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  className="list-filters-wrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center"
                    }}
                  >
                    <RadioGroup
                      name="paymentsFilters"
                      value={this.state.filter}
                      onChange={this.changeFilter}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: "15px"
                      }}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio color="primary" />}
                        label={
                          (<span>{this.trans("all")}</span>)}
                      />
                      <FormControlLabel
                        value="unused"
                        control={<Radio color="primary" />}
                        label={
                          (<span>{this.trans("to-verify")}</span>)}
                      />
                    </RadioGroup>
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table padding-last-item"
                  subtitle={this.trans("page/banktransactionfile-section/listoftransaction-info/transactionnotfound")}
                  rows={this.getPaymentsForList()}
                  rowsLength={this.getAmountsOfFilteredPayments(this.state.filter)}
                  fetch={this.fetchPayments}
                  isFetching={this.state.isFetching}
                />
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isBankTransactionsDilaogOpen}
          title={this.trans("title-attention") + "!"}
          content={(
            <div>
              <div>
                {this.trans("preprocess/selectbanktransactionfile-info")}
              </div>
              <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button
                  color="primary"
                  style={{
                    marginRight: "7px",
                    position: "relative",
                    zIndex: 2
                  }}
                  onClick={() => {this.setState({isBankTransactionsDilaogOpen: false})}}
                >
                  {this.trans("dialog-button/cancel")}
                </Button>
                <input
                  type="file"
                  accept=".STA, .940"
                  style={{
                    display: "none"
                  }}
                  multiple={false}
                  onChange={this.upload}
                  id="button-file"
                  ref={this.fileInput}
                />
                <label htmlFor="button-file">
                  <Button
                    variant="contained"
                    color="primary"
                    className={"new-attachment-button"}
                    onClick={() => this.fileInput.current.click()}
                  >
                    {this.trans("dialog-button/selectmt940file")}
                  </Button>
                </label>
              </div>
            </div>
          )}
          onClose={this.closeBankTransactionsDialog}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          title={!!fileDetails && fileDetails.state === 3 ? this.trans("processing-file") : (!!fileDetails && fileDetails.title) || this.trans("uploading")}
          content={this.renderDialogContent()}
          openLeavePrompt={this.state.isDialogOpen}
          onSave={this.closeDialog}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={
            [
              (!!fileDetails && !fileDetails.disableButton && fileDetails.state !== 4 && fileDetails.countOfCreatedPayments !== 0 &&
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!!fileDetails && fileDetails.disableButton}
                  onClick={this.continue}
                >
                  {this.trans("button-close")}
                </Button>
              ),
              // <Button
              //   variant="contained"
              //   color="primary"
              //   disabled={!!fileDetails && fileDetails.disableButton}
              //   onClick={this.continue}
              // >
              //   {this.determineTitle()}
              // </Button>
            ]
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    payments: state.payments,
    component: state.bankTransactions,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  BankTransactions
);
